/**
 * A control inside a panel's brand bar (A-#234, A-#235, Arthur, 28 October 2026): the Documents bar's look, taken
 * from its "+" (AddTopFolder.tsx) so the two cannot drift. 44px to touch, the bar's own on-brand text, a light wash on
 * hover, which dark mode redefines through the tokens; focus is the browser's own ring, as on Documents.
 */
export const BAR_ACTION = 'inline-flex min-h-[44px] items-center justify-center rounded-lg px-3 font-semibold hover:bg-on-brand/10';
